import {
  BENEFITS_LOADING,
  BENEFITS_SUCCESS,
  BENEFITS_FAILED
} from '../actions/benefitActions'
const Benefits = (state = {}, action) => {
  switch (action.type) {
    case BENEFITS_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        benefits: null,
        error: null
      })
    case BENEFITS_SUCCESS:
      return Object.assign({}, state, {
        benefits: action.response,
        error: null,
        isLoading: false
      })
    case BENEFITS_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        benefits: null,
        isLoading: false
      })
    default:
      return state
  }
}
export default Benefits



// WEBPACK FOOTER //
// ./src/redux/reducers/benefitReducer.js